import { LOGIN, LOGOUT, SENDTOKEN } from '../Actions/Account'
import { FAIL_FETCH } from '../Actions/Other'

const initialState = {
  token: '',
  ID: '',
  redirect: '',
  user: {},
  userAnalyticsEnabled: false
}

/**
  * AccountReducer
  * @desc account reducer that handles account section of the state
  * @param {Object} state
  * @param {action} action
  * @return {Object} state
*/
export default function AccountReducer (state, action) {
  if (typeof state === 'undefined') {
    return initialState
  }

  switch (action.type) {
    case SENDTOKEN:
      return Object.assign({}, state, {
        token: action.query.token,
        subdomain: action.query.subdomain
      })
    case LOGIN:
      return Object.assign({}, state, { ID: action.user.accountId, redirect: action.user.logoutUrl, user: action.user, userAnalyticsEnabled: action.user.userAnalyticsEnabled, subdomain: state.subdomain })
    case LOGOUT:
      // return Object.assign({}, state, {token: state.token, ID: state.ID})
      return Object.assign({}, state, { token: '', ID: '', user: {}, userAnalyticsEnabled: false })
    case FAIL_FETCH:
      return state
    default:
      return state
  }
}
